import styled from 'styled-components';

import { StyledComponent } from '../../interfaces';

import { IconSVGProps } from './icon.types';

export const IconSVG: StyledComponent<'svg', IconSVGProps> = styled.svg<IconSVGProps>`
  display: inline-block;
  width: 1em;
  height: 1em;
  stroke-width: 0;
  stroke: ${({ $color }: IconSVGProps): string => $color ?? 'currentColor'};
  fill: ${({ $fill }: IconSVGProps): string => $fill ?? 'transparent'};
  font-size: ${({ $size }: IconSVGProps): number => $size}px;

  // generated by icomoon.io
  &.icon-download {
    width: 1.0498046875em;
  }

  &.icon-insertLink {
    width: 1.0498046875em;
  }

  &.icon-warning {
    width: 1.0498046875em;
  }

  &.icon-leftArrow {
    width: 1.0419921875em;
  }

  &.icon-arrowRight15 {
    width: 1.0419921875em;
  }

  &.icon-arrowLeft25 {
    width: 1.0419921875em;
  }
`;
